import React from "react";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAdminAuth } from "./AdminAuthContext";
import {
  Users, Boxes, Workflow, Activity, FlaskConical, BarChart3,
  LogOut, ShieldCheck, Settings, Info, Image as ImageIcon,
} from "lucide-react";

const NAV = [
  { to: "/admin", label: "Dashboard", Icon: Activity, end: true },
  { to: "/admin/users", label: "Utenti & Dispositivi", Icon: Users },
  { to: "/admin/algorithms", label: "Algoritmi", Icon: Boxes },
  { to: "/admin/scheduler", label: "Scheduler", Icon: Workflow },
  { to: "/admin/quality", label: "Qualità Dati", Icon: ShieldCheck },
  { to: "/admin/sandbox", label: "Sandbox", Icon: FlaskConical },
  { to: "/admin/analytics", label: "Analytics", Icon: BarChart3 },
  { to: "/admin/infopoints", label: "Infopoint", Icon: Info },
  { to: "/admin/branding", label: "Branding", Icon: ImageIcon },
  { to: "/admin/config", label: "Configurazione", Icon: Settings },
];

export default function AdminLayout() {
  const { admin, logout } = useAdminAuth();
  const nav = useNavigate();
  return (
    <div className="min-h-screen text-white" style={{ background: "#0b1114" }}>
      <div className="flex">
        <aside className="w-[260px] min-h-screen border-r border-white/5 bg-[#0d1519] flex flex-col">
          <div className="px-5 py-5 flex items-center gap-3">
            <div
              className="w-9 h-9 rounded-lg flex items-center justify-center"
              style={{ background: "linear-gradient(155deg,#12b096,#0a8670)" }}
            >
              <ShieldCheck size={18} className="text-white" />
            </div>
            <div>
              <div className="text-white text-sm font-semibold">SmartDream</div>
              <div className="text-white/50 text-[11px]">Admin Console</div>
            </div>
          </div>

          <nav className="px-3 mt-2 flex-1">
            {NAV.map((n) => (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `flex items-center gap-3 px-3 py-2.5 rounded-lg text-[13px] font-medium transition-colors mb-0.5 ${
                    isActive
                      ? "bg-[#14c2a1]/15 text-white border border-[#14c2a1]/30"
                      : "text-white/70 hover:text-white hover:bg-white/5 border border-transparent"
                  }`
                }
              >
                <n.Icon size={16} />
                {n.label}
              </NavLink>
            ))}
          </nav>

          <div className="p-3 border-t border-white/5">
            <div className="rounded-lg bg-white/5 border border-white/10 px-3 py-2">
              <div className="text-[11px] text-white/50">Connesso come</div>
              <div className="text-sm text-white font-medium truncate">
                {admin?.email}
              </div>
            </div>
            <button
              onClick={() => {
                logout();
                nav("/admin/login", { replace: true });
              }}
              className="mt-2 w-full h-9 rounded-lg bg-white/5 border border-white/10 hover:bg-rose-500/10 hover:border-rose-400/30 text-white/85 text-[12px] font-medium flex items-center justify-center gap-2 transition-colors"
            >
              <LogOut size={14} /> Disconnetti
            </button>
          </div>
        </aside>

        <main className="flex-1 min-h-screen">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
